var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quillEditor',{ref:"myQuillEditor",staticClass:"roma-editor",attrs:{"content":_vm.description,"options":_vm.editorOption},on:{"change":function($event){return _vm.onEditorChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }